export const closeFrame = (v) => $.frame.close(v);
